import { useState, useCallback } from 'react';

export type FormMode = 'view' | 'add' | 'edit';

export function usePWP253Mode() {
  const [mode, setMode] = useState<FormMode>('view');

  const toView = useCallback(() => setMode('view'), []);
  const toAdd = useCallback(() => setMode('add'), []);
  const toEdit = useCallback(() => setMode('edit'), []);

  const isView = mode === 'view';
  const isAdd = mode === 'add';
  const isEdit = mode === 'edit';
  const isEditing = isAdd || isEdit;

  return { mode, setMode, toView, toAdd, toEdit, isView, isAdd, isEdit, isEditing };
}
